import Vue from "vue";
import {
  message,
  Button,
  Dropdown,
  Icon,
  Mentions,
  Modal,
  Radio,
  Slider,
  Spin,
  Tooltip,
  Popover,
  Progress,
} from "ant-design-vue";
import "./index.scss";

Vue.use(Button);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Mentions);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Slider);
Vue.use(Spin);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Progress);

message.config({
  top: "40%",
  maxCount: 3,
});

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$info = Modal.info;
